import React from 'react'
import Footer from './footer'
import Banner from './section/banner'
import Categories from './section/categories';
import Counter from './section/counter';
import FeaturedInstitutions from './section/featured-institutions';
import Masterskill from './section/master-skill';
import Experienced from './section/experienced';
import Knowledge from './section/knowledge';
import Testimonials from './section/testimonials';
import Latestblog from './section/latest-blog';

const HomeSix = () => {


  return (
    <>
      <Banner />
      <Categories />
      <Counter />
      <FeaturedInstitutions />
      <Masterskill />
      <Experienced />
      <Knowledge />
      <Testimonials />
      <Latestblog />
      {/* <Footer /> */}
    </>
  )
}

export default HomeSix
